import React, {Component} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import * as Actions from "../../actions/actions";
import {mixins} from "../../mixins";
import {rgba} from "polished";
import H from "../typography/H";
import Counter from "../common/Counter";
import Button from "../common/Button";
import QuantityCounter from "../common/QuantityCounter";
import {priceFormat} from "../../formaters";
import CheckBox from "../common/CheckBox";

const Overlay = styled.div`
  background-color: ${p => rgba(p.theme.cBlack, 0.7)};
  ${mixins.stretch()};
`;

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

const Body = styled.div`
  width: 100%;
  max-width: 500px;
  margin: auto;
  //min-height: 100%;
  //max-height: 100%;
  padding: 30px;
  background-color: ${p => p.theme.cWhite};
  display: flex;
  flex-direction: column;
  pointer-events: auto;
`;

const Title = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

const Quantity = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 40px;
`;

const SubTitle = styled.div`
  text-align: center;
  font-weight: bold;
  font-size: ${p => p.theme.sFontBig}px;
  margin-bottom: 10px;
`;

const QuantityLabel = styled.div`
  font-size: ${p => p.theme.sFontMicro}px;
  margin-top: 10px;
`;

const ModalActions = styled.div`
 
`;

const Total = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const TotalPrice = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const TotalCaption = styled.div`
  font-size: ${p => p.theme.sFontMicro}px;
`;

const Mods = styled.div`
`;

const ModsContainer = styled.div`
`;

class Cart extends Component {

    constructor(props) {
        super(props);
    }

    handleAdd = (redirect = false) => {
        this.props.closeAddToCartModal();
        if (redirect) this.props.history.push('/cart');
    };

    handleModCheck = (modId, value) => {
        console.log(modId, value);
    };

    getMods = () => {
        return this.props.mods.map((mod, key) => {
            return <div className="col-sm-6" key={key}>
                <CheckBox
                          callback={(value) => this.handleModCheck(mod.id, value)}
                          checked={true}
                          type="checkbox"
                          name="delivery"
                          label={mod.title}/>
            </div>
        })
    };

    render() {
        const {item, order} = this.props;
        if (this.props.addToCartModal) {
            return (
                <div className={this.props.className}>
                    <Wrapper>
                        <Body>
                        <Title>
                            <H size={2} styleSize={2}>{item.size.x + '×' + item.size.y + 'мм'}</H>
                        </Title>
                        <Quantity>
                            <SubTitle>
                                Количество
                            </SubTitle>
                            <QuantityCounter id={this.props.addToCartModal.id}/>
                            <QuantityLabel>
                                На складе имеется <strong>3</strong> единицы этого товара
                            </QuantityLabel>
                        </Quantity>
                        <Mods>
                            <SubTitle>
                                Дополнения
                            </SubTitle>
                            <ModsContainer className="row">
                                {this.getMods()}
                            </ModsContainer>
                        </Mods>
                        <Total>
                            <SubTitle>
                                Итого
                            </SubTitle>
                            <TotalPrice>{priceFormat(order.quantity * item.price)}</TotalPrice>
                            <TotalCaption>НДС включен</TotalCaption>
                        </Total>
                        <ModalActions>
                            <div className="row">
                                <div className="col-sm-6">
                                    <Button onClick={() => this.handleAdd()} fullWidth wireframe label={'Отложить'}/>
                                </div>
                                <div className="col-sm-6">
                                    <Button onClick={() => this.handleAdd(true)} fullWidth label={'Купить'}/>
                                </div>
                            </div>
                        </ModalActions>
                        </Body>
                    </Wrapper>
                    <Overlay onClick={() => this.props.closeAddToCartModal()}/>
                </div>
            );
        } else {
            return '';
        }
    }
}


function mapStateToProps(state) {
    const addToCartModal = state.getIn(['cart', 'addToCartModal']);
    const item = addToCartModal ? state.get('products').find((product) => {
        return product.get('id') === addToCartModal.get('product_id');
    }) : false;
    let order = false;
    if (addToCartModal) {
        order = state.getIn(['cart', 'items']).find((product) => {
            return product.get('id') === addToCartModal.get('id');
        });
    }
    //console.log(state.getIn(['cart']));
    return {
        addToCartModal,
        item,
        order,
        mods: state.getIn(['cart', 'mods']),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeAddToCartModal: Actions.closeAddToCartModal,
        redirect: Actions.redirect,
        addToCart: Actions.addToCart,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(styled(Cart)`
  display: flex;
  z-index: ${p => p.theme.zAboveMenu};
  top: 0;
  left: 0;
  ${mixins.stretch()};
  position: fixed;
`));